import { render, staticRenderFns } from "./allocation.vue?vue&type=template&id=ddc853ac&scoped=true&"
import script from "./allocation.js?vue&type=script&lang=js&"
export * from "./allocation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc853ac",
  null
  
)

export default component.exports